import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { DropDownItemComponent } from '../../../shared/component/drop-down-item/drop-down-item.component';
import { EMPLOYEE_SORT, EmployeeDTO, UpdateEmployeeManageUsersEvent } from '../../../user/employee/dto/EmployeeDTO';
import { Subject } from 'rxjs';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ThreeDotsMenuComponent } from '../../../shared/component/three-dots-menu/three-dots-menu.component';
import { AuthService } from '../../../auth/service/auth.service';
import { SortDirective } from '../../../../util/directives/sort/sort.directive';
import { SwitcherComponent } from '../../../shared/component/switcher/switcher.component';
import { EmployeeRoleDisplayPipe } from '../../../../util/pipes/employee-role-display.pipe';

@Component({
  selector: 'app-team-table',
  templateUrl: './team-table.component.html',
  styleUrls: ['./team-table.component.scss'],
  imports: [
    MatMenu,
    DropDownItemComponent,
    MatMenuTrigger,
    ThreeDotsMenuComponent,
    SortDirective,
    SwitcherComponent,
    EmployeeRoleDisplayPipe,
  ],
})
export class TeamTableComponent implements OnDestroy, OnInit {
  private _destroyStream: Subject<void> = new Subject<void>();
  private authService = inject(AuthService);

  readonly employeeSort = EMPLOYEE_SORT;

  @Input() employees: EmployeeDTO[] = [];
  @Input() isAbleToManageUsers = false;
  @Input() modalMode = false;

  @Output() deleteUser = new EventEmitter<EmployeeDTO>();
  @Output() resendInvite = new EventEmitter<EmployeeDTO>();
  @Output() updateIsAbleToManageUsers = new EventEmitter<UpdateEmployeeManageUsersEvent>();

  currentUserEmail: string;
  selectedEmployee: EmployeeDTO;

  ngOnInit(): void {
    this.currentUserEmail = this.authService.userInfoValue.mail;
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  onDelete(employee: EmployeeDTO): void {
    this.deleteUser.emit(employee);
  }

  onResendInvite(employee: EmployeeDTO): void {
    this.resendInvite.emit(employee);
  }

  sendEmail(email: string): void {
    window.location.href = `mailto:${email}`;
  }

  chosenUserEmitter(employee: EmployeeDTO): void {
    this.selectedEmployee = employee;
  }

  onIsAbleToManageUsersChange(employee: EmployeeDTO, isAbleToManageUsers: boolean): void {
    if (employee.isAbleToManageUsers === isAbleToManageUsers) {
      return;
    }
    this.updateIsAbleToManageUsers.emit({ employee, isAbleToManageUsers });
  }
}
